import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { useTheme } from '../theme/ThemeContext';

/** Sun / ray icon — used for theme toggle (matches mockup). */
function ThemeIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4m11.4-11.4 1.4-1.4" />
    </svg>
  );
}

const NavBar = ({ onLogout, user }) => {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();
  const firstName = user?.first_name || user?.username || 'there';

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <header className="app-nav" aria-label="Primary">
      <div className="app-nav-inner">
        <NavLink to="/dashboard" className="brand">
          Pocket<span>Guru</span>
        </NavLink>
        <nav className="nav-links">
          <NavLink to="/dashboard">Dashboard</NavLink>
          <NavLink to="/analytics">Analytics</NavLink>
          <NavLink to="/expenses">Expenses</NavLink>
          <NavLink to="/archive">Archive</NavLink>
        </nav>
        <div className="nav-right">
          <span className="welcome">
            Welcome, <strong>{firstName}</strong>
          </span>
          <button
            type="button"
            className={`icon-btn ${theme === 'dark' ? 'on' : ''}`}
            onClick={toggleTheme}
            title={theme === 'dark' ? 'Switch to light' : 'Switch to dark'}
            aria-label="Toggle light and dark theme"
          >
            <ThemeIcon />
          </button>
          <NavLink
            to="/settings"
            className={({ isActive }) => `icon-btn${isActive ? ' on' : ''}`}
            title="Settings"
            aria-label="Settings"
          >
            <Settings size={18} strokeWidth={1.8} />
          </NavLink>
          <button type="button" className="btn-logout" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default NavBar;
